module.exports = __webpack_public_path__ + "img/detail2.a7d855f2.jpg";